import React from 'react';
import { AuthShell } from './GoPalLogo';

export function TrialExpiredScreen({ onSignOut }: { onSignOut: () => void }) {
  return (
    <AuthShell>
      <div className="text-center">
        <div
          style={{
            width: 48, height: 48,
            background: 'var(--amber)',
            borderRadius: 'var(--r-lg)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
            boxShadow: '0 2px 8px rgba(255,149,0,.4)',
          }}
        >
          <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, fill: '#fff' }}>
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
        </div>
        <h1 className="text-xl font-bold" style={{ letterSpacing: '-.02em', color: 'var(--text)', marginBottom: 8 }}>
          Trial Period Ended
        </h1>
        <p className="text-md mb-6" style={{ color: 'var(--text2)', lineHeight: 1.5 }}>
          Your free trial of GoPal has ended. Your data is safe and will be available once you upgrade.
        </p>
        <p className="text-sm text-muted mb-6">Contact us to continue using GoPal:</p>
        <a
          className="btn btn-primary btn-lg"
          href="mailto:hello@getgopal.co.nz"
          style={{ textDecoration: 'none', display: 'inline-flex' }}
        >Contact GoPal</a>
        <div className="mt-5">
          <button
            onClick={onSignOut}
            style={{
              background: 'none', border: 'none',
              color: 'var(--text3)', fontSize: 'var(--fs-sm)',
              cursor: 'pointer', textDecoration: 'underline',
              fontFamily: 'inherit',
            }}
          >Sign out</button>
        </div>
      </div>
    </AuthShell>
  );
}
